export const nativeAlertKeys = ['taskCompleted', 'taskAttention', 'mediaCompleted', 'announcements'];

export function nativeNotificationEnabled(preferences, key) {
  if (key === 'announcements' && preferences?.announcements == null) {
    return nativeAlertKeys.slice(0, 3).some(category => preferences?.[category] !== false);
  }
  return preferences?.[key] !== false;
}
